import React, { useState, useLayoutEffect } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const useStyles = makeStyles((theme) => ({
  selectField: {
      width: '200px',
    }
  }));
  
  const SelectSimpleComponent = (props) => {
    const classes = useStyles();
    const [themeType,setThemeType] = useState('dark');
    const [condition, setCondition] = React.useState("1st");

    const handleChange = (e) => {
      setCondition(e.target.value);
    };
    useLayoutEffect(() => {
        if(props.activeModeClass === "white-content"){  setThemeType("light")}
        else{setThemeType("dark")}
        
      }, []);
      const THEME = createMuiTheme({
        palette: {
          type: themeType,
          primary: {
            main: '#f8955e',
          },
          secondary: {
            main: '#1d8cf8',
          },
        },
      });
      return (
          <div>
              <MuiThemeProvider theme={THEME}>
               <CssBaseline/>   
               <FormControl >
                <InputLabel shrink id="condition-select">
                 Select a day
                </InputLabel>
                <Select
                  labelId="condition-label"
                  id="condition-select"
                  value= {props.selVal}
                  onChange={props.onChange}
                  className={classes.selectField}
                  displayEmpty
                >
                  <MenuItem value="1st">1st</MenuItem>
                  <MenuItem value="2nd">2nd</MenuItem>
                  <MenuItem value="3rd">3rd</MenuItem>
                  <MenuItem value="4th">4th</MenuItem>
                  <MenuItem value="5th">5th</MenuItem>
                  <MenuItem value="6th">6th</MenuItem>
                  <MenuItem value="7th">7th</MenuItem>
                  <MenuItem value="8th">8th</MenuItem>
                  <MenuItem value="9th">9th</MenuItem>
                  <MenuItem value="10th">10th</MenuItem>
                  <MenuItem value="11th">11th</MenuItem>
                  <MenuItem value="12th">12th</MenuItem>
                  <MenuItem value="3th">1th3</MenuItem>
                  <MenuItem value="14th">14th</MenuItem>
                  <MenuItem value="15th">15th</MenuItem>
                  <MenuItem value="16th">16th</MenuItem>
                  <MenuItem value="17th">17th</MenuItem>
                  <MenuItem value="18th">18th</MenuItem>
                  <MenuItem value="19th">19th</MenuItem>
                  <MenuItem value="20th">20th</MenuItem>
                  <MenuItem value="21st">2st</MenuItem>
                  <MenuItem value="22nd">22nd</MenuItem>
                  <MenuItem value="23rd">23rd</MenuItem>
                  <MenuItem value="24th">24th</MenuItem>
                  <MenuItem value="25th">25th</MenuItem>
                  <MenuItem value="26th">26th</MenuItem>
                  <MenuItem value="27th">27th</MenuItem>
                  <MenuItem value="28th">28th</MenuItem>
                  <MenuItem value="29th">29th</MenuItem>
                  <MenuItem value="30th">30th</MenuItem>
                  <MenuItem value="31st">31st</MenuItem>
                  <MenuItem value="Last Day Of The Month">Last Day Of The Month</MenuItem>       
                </Select>
              </FormControl>
               
              </MuiThemeProvider>
          </div>
      )
  }
  export default SelectSimpleComponent;